import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1
    },
    main: {
        maxWidth: '100%',
        height: '100vh',
        backgroundColor: '#fff',
        [theme.breakpoints.up('tablet')]: {
            backgroundColor: '#5675D3',
        }
    },
    container: {
        paddingRight: '14%',
        paddingLeft: '14%',
        marginRight: 'auto',
        marginLeft: 'auto'
    },
    container_fluid: {
        paddingRight: '10%',
        paddingLeft: '10%',
        marginRight: 'auto',
        marginLeft: 'auto'
    },
    header: {
    },
    title: {
        flexGrow: 1,
        color: 'black',
        marginLeft: '-3%',
        marginBottom: '-8px'
    },
    link: {
        color: '#537ED4',
        textDecoration: 'none',
        '&:hover': {
            color: '#3333B0',
            cursor: 'pointer'
        }
    },
    body: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: '130px'
    },
    box: {
        position: 'relative',
        backgroundColor: 'white',
        marginTop: "5%",
        borderRadius: '5px',
        zIndex: '5',

        [theme.breakpoints.up('tablet')]: {
            width: '400px',
            height: 'auto',
            marginTop: "5%",
        }
    },
    box_container: {
        position: 'relative',
        marginLeft: '5%',
        marginRight: '5%'
    },
    box_head: {
        marginBottom: '20px',
        paddingTop: '20px',
        marginLeft: '40px'
    },
    box_head_logo: {
        position: 'absolute',
        left: '-225px',
        top: '-55px',

        [theme.breakpoints.up('tablet')]: {
            left: '-215px',
            top: '-55px',

        }
    },
    box_head_text: {
        textAlign: 'center',
        '& h1': {
            fontWeight: 'normal',
            fontSize: '1.5rem',
            marginBottom: '0'
        },
        '& p': {
            fontSize: '0.8rem',
            marginTop: '0',
            '& a': {
                marginLeft: '3px'
            }
        }
    },
    box_body: {
        marginTop: '30px'
    },
    box_form: {
        width: '100%'
    },
    forgot_password: {
        textAlign: 'right',
        marginTop: '-10px'
    },
    gelombang: {
        position: 'absolute',
        zIndex: '1',
        width: '100%',
        '& img': {
            width: '100%'
        },
        bottom: '0'
    },
    toko: {
        position: 'absolute',
        zIndex: '2',
        width: '100%',
        '& img': {
            width: '100%',
            bottom: '0'
        },
        bottom: '0',
        left: '0',
        [theme.breakpoints.up('tablet')]: {
            marginBottom: '-9px',
            bottom: '0',
        },
    },
    footer: {
        width: '100%',
        minHeight: '535px',
        backgroundColor: '#F0F1FF'
    },
    copyright: {
        position: 'absolute',
        zIndex: '3',
        color: '#537ED4',
        bottom: '100px',
        fontSize: '0.8rem',
        marginTop: 10,

        [theme.breakpoints.up('tablet')]: {
            backgroundColor: '#8ca7f3a1',
            color: 'white',
        },

        [theme.breakpoints.down('320')]: {
            color: 'white',
        },
    },
    footer_logo: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        paddingTop: '50px',
        justifyContent: 'center',
        '& img': {
            width: '184px'
        }
    },
    footer_copy: {
        textAlign: 'center',
        marginTop: '10px'
    },
    footer_info: {
        width: '100%',
        marginTop: '60px',
        display: 'flex',
        justifyContent: 'space-between',
        '& a': {
            color: 'inherit',
            textDecoration: 'none',
            '&:hover': {
                color: '#537ED4'
            }
        }
    },
    icon_link: {
        textDecoration: 'none',
        color: 'inherit',
        '&:hover': {
            color: '#537ED4'
        },
        marginRight: '15px'
    },
    appstores: {
        display: 'flex',
        marginLeft: '-30px',
        paddingTop: '43px',
        cursor: 'pointer',
        textAlign: 'right',
    },
    alamat: {
        marginLeft: '-30px',
        [theme.breakpoints.down('sm')]: {
            marginLeft: '0'
        }
    }
}));

export default useStyles;